import React, { useEffect, useState, useRef } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
  Snackbar,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  reSendEmailOTPAPICall,
  NRIValidateEmailOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import ConfitmEmailOtpStyles from "../pages/Styles/ConfirmEmailOtp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Slide, { SlideProps } from "@mui/material/Slide";
import firstockLogo from "../Components/assets/Images/firstockLogoBadge.svg";
import otpIcon from "../Components/assets/Images/otpIcon.svg";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}
const dots = ["1", "2", "3", "4", "5", "6"];
export default function ConfirmEmailOtpPage() {
  const navigate = useNavigate();
  const emailID: any = sessionStorage.getItem("emailID");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [wrongOTP, setWrongOTP] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const navigationData = routesData;
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);

  const latitude: any = sessionStorage.getItem("latitude");
  const longitude: any = sessionStorage.getItem("longitude");

  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsButtonDisabled(true);
    setCountdown(30);

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }, []);

  const SaveIPAddress = (responseData: any) => {
    let objIPAddress: any = {
      latitude: latitude,
      longitude: longitude,
    };
    SaveIpAddressAPICall(objIPAddress)
      .then((response: any) => {
        // console.log("responseIPSave", response.data);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        if (error.response.data.message) {
          setMessage(
            error.message.includes("Network")
              ? "Error occured, Please try again"
              : error.response.data.message,
          );
        } else {
          setMessage("Error occured, Please try again");
        }
        setloading(false);
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  };

  function emailOTPValidation(emailOTP: any) {
    // console.log("emailOTP", emailOTP);
    let obj: any = {
      email: emailID,
      email_otp: emailOTP,
    };
    NRIValidateEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setWrongOTP(false);
        setloading(false);
        if (responseData.data.access_token) {
          // console.log("token", responseData.data.access_token);
          sessionStorage.setItem(
            "access-token",
            responseData.data.access_token,
          );
        }
        SaveIPAddress(responseData);
        // if (
        //   responseData.data.next_stage &&
        //   navigationData.hasOwnProperty(responseData.data.next_stage)
        // ) {
        //   navigate(navigationData[responseData.data.next_stage]);
        // }
        //navigate("/panverification");
      })
      .catch((error: any) => {
        setloading(false);
        setWrongOTP(true);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function reSendemailOTP() {
    let obj: any = {
      email: emailID,
    };
    reSendEmailOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setTransition(() => TransitionUp);
        setOpen(true);
        setIsButtonDisabled(true);
        setCountdown(30);
        setTimeout(() => {
          setOpen(false);
        }, 5000);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
      })
      .catch((error: any) => {
        setMessage(
          error.message.includes("Network")
            ? "Error sending OTP"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const handleBackClick = () => {
    navigate("/email");
  };

  const handleResendOTP = () => {
    setloading(true);
    reSendemailOTP();
  };

  function validateEmailOTP(value: any) {
    let error: any;
    if (!value) {
      error = "Email OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any,
  ) => {
    setFieldValue(name, value);
    //console.log( value);
    if (value.length === 6) {
      emailOTPValidation(value);
    }
  };
  return (
    <>
      <SnackBar message={message} />
      <div className={ConfitmEmailOtpStyles.wrapper}>
        <div className={ConfitmEmailOtpStyles.RightContainer}>
          <div className={ConfitmEmailOtpStyles.topLogoSection}>
            <img src={firstockLogo} className={ConfitmEmailOtpStyles.topLogo} />
          </div>
          <div className={ConfitmEmailOtpStyles.contentSection}>
            <div className={ConfitmEmailOtpStyles.headerSection}>
              <p className={ConfitmEmailOtpStyles.signup}>OTP Authentication</p>
              <p className={ConfitmEmailOtpStyles.subText}>
                6 Digit code sent to your Email <span>{emailID}</span>
                <a
                  onClick={handleBackClick}
                  className={ConfitmEmailOtpStyles.change}
                >
                  (Change)
                </a>
              </p>
            </div>

            <Formik
              initialValues={{
                emailotp: "",
              }}
              onSubmit={(values) => {
                //   console.log(values);
                setloading(true);
                emailOTPValidation(values.emailotp);
              }}
            >
              {({
                errors,
                touched,
                handleChange,
                values,
                handleSubmit,
                setFieldValue,
              }) => (
                <Form
                  onKeyDown={(event) => {
                    // event.code === "Enter" ||
                    //   (event.code === "NumpadEnter" && handleSubmit());

                    event.code.includes("Enter") && handleSubmit();
                  }}
                  style={{ width: "100%" }}
                >
                  <div style={{ width: "100%", position: "relative" }}>
                    <Field
                      sx={{
                        fieldset: {
                          borderColor: "#E5E7EB",
                          borderRadius: "100px",
                          height: "60px",
                        },
                      }}
                      name="emailotp"
                      validate={validateEmailOTP}
                      render={({ field }) => (
                        <TextField
                          autoFocus
                          {...field}
                          label=""
                          className={ConfitmEmailOtpStyles.textfield}
                          variant="outlined"
                          value={values.emailotp}
                          type="numeric"
                          onChange={(event) => {
                            const updatedValue = event.target.value;
                            handleChangeField(
                              "emailotp",
                              updatedValue,
                              setFieldValue,
                              values,
                            );
                          }}
                          inputProps={{
                            sx: {
                              "&::placeholder": {
                                paddingLeft: "-20px",

                                fill: "var(--Black-Black-500, #6B7280)",
                                fontWeight: 600,
                                fontSize: "2.19rem",
                                background: "transparent",
                                height: "29px",
                                letterSpacing: "19px",
                              },
                              // borderLeft: "1px solid #E5E7EB",
                              // height: "30px",
                              paddingLeft: "-20px",

                              fontWeight: 500,
                              letterSpacing: { xs: "29.5px", sm: "24.5px" },
                              background: "transparent",
                            },
                            maxLength: 6,
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{
                                  // borderRight: "1px solid #E5E7EB",
                                  // height: "22px",
                                  paddingRight: "10px",
                                  paddingLeft: "5px",
                                }}
                              >
                                <img src={otpIcon} />
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const isValidKey = /^\d+$/.test(keyValue);

                            if (!isValidKey) {
                              event.preventDefault();
                            }
                          }}
                        />
                      )}
                    />

                    <FormHelperText
                      style={{
                        color: "#d32f2f",
                        height: "10px",
                        marginTop: "3px",
                        textAlign: "center",
                      }}
                    >
                      {touched.emailotp && errors.emailotp?.toString()}
                    </FormHelperText>

                    {values.emailotp.length === 0 && (
                      <div className={ConfitmEmailOtpStyles.placeholderstyling}>
                        {dots.map((a: any, index: any) => (
                          <div
                            className={ConfitmEmailOtpStyles.dot}
                            style={{
                              opacity:
                                values.emailotp.length + 1 >= index + 1
                                  ? "0.4"
                                  : "1",
                            }}
                          ></div>
                        ))}
                      </div>
                    )}
                    {values.emailotp.length > 0 && (
                      <div className={ConfitmEmailOtpStyles.placeholderstyling}>
                        {dots.map((a: any, index: any) => (
                          <div
                            className={ConfitmEmailOtpStyles.dot}
                            style={{
                              opacity:
                                values.emailotp.length + 1 >= index + 1
                                  ? "0.4"
                                  : "1",
                              visibility:
                                values.emailotp.length >= index + 1
                                  ? "hidden"
                                  : "visible",
                            }}
                          ></div>
                        ))}
                      </div>
                    )}

                    {isButtonDisabled ? (
                      <div className={ConfitmEmailOtpStyles.resendSection}>
                        <p className={ConfitmEmailOtpStyles.clickhere}>
                          Resend OTP in {countdown} Seconds
                        </p>
                      </div>
                    ) : (
                      <div className={ConfitmEmailOtpStyles.resendSection}>
                        <LoadingButton
                          onClick={handleResendOTP}
                          // loading={loading}
                          variant="text"
                          id="confirmEmailOtpResendOTPButton"
                          sx={{
                            marginTop: "10px",
                            color: "#006779",
                            height: "max-content",
                          }}
                        >
                          Resend OTP
                        </LoadingButton>
                      </div>
                    )}

                    <div className={ConfitmEmailOtpStyles.buttonSection}>
                      {values.emailotp.length === 6 ? (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          loading={loading}
                          id="confirmEmailOtpContinueButton"
                          className={ConfitmEmailOtpStyles.button}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          id="confirmEmailOtpContinueDisabledButton"
                          className={ConfitmEmailOtpStyles.button}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                    <Snackbar
                      open={open}
                      autoHideDuration={3000}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      TransitionComponent={transition}
                      sx={{ marginTop: "50px" }}
                    >
                      <div
                        style={{
                          background: "#54BF00",
                          borderRadius: "10px ",
                        }}
                      >
                        <div style={{ marginLeft: "30px" }}>
                          <Alert
                            icon={false}
                            severity="success"
                            sx={{
                              width: "max-content",
                              height: "50px",
                              fontSize: "16px",
                              borderRadius: "0",
                            }}
                          >
                            Successfully sent the OTP to your Email.
                          </Alert>
                        </div>
                      </div>
                    </Snackbar>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
